export default () => {
    return {
        delay: false,
        scrollSettings: false,

        mounted(delay = this.$store.animationDelay, scrollTrigger = true) {
            if (scrollTrigger) {
                this.scrollSettings = {
                    trigger: this.$refs.wrapper,
                    toggleActions: 'play none play none'
                };
            }

            this.delay = delay;

            this.animate();
        },

        animate() {
            const split = new SplitText(this.$refs.wrapper, { type: 'chars, words, lines' });

            gsap.fromTo(
                split.chars,
                { opacity: 0, yPercent: 40 },
                {
                    opacity: 1,
                    yPercent: 0,
                    duration: 0.2,
                    stagger: 0.005,
                    delay: this.delay,
                    ease: 'circ.out',
                    scrollTrigger: this.scrollSettings
                }
            );
        }
    };
};
